let reduxDispatch = (action) => {
  throw new Error('dispatch not set');
};

export const RESET_APP_STATE = 'RESET_APP_STATE';

export default async function ResetAppState() {
  reduxDispatch({ type: RESET_APP_STATE });
}

export function SetResetAppStateFunction(dispatch) {
  reduxDispatch = dispatch;
}
